import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { oktaConfig } from './configuration/okta';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    OktaAuthModule,
  ],
  exports: [
  ],
  providers: [
    { provide: OKTA_CONFIG, useValue: oktaConfig }
  ]
})
export class OktaModule { }
